type LabelProps = {
  name: string;
  className?: string;
};

const Label = (LabelProps: LabelProps) => {
  return (
    <>
      <label
        key={LabelProps.name}
        className={LabelProps.className ?? "mb-2 leading-4 text-sm"}
        htmlFor={LabelProps.name}
      >
        {LabelProps.name}
      </label>
    </>
  );
};

export default Label;
